import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from "js-cookie";
// Set your API base URL
const BASE_URL = process.env.REACT_APP_BASE_URL;


// Thunks for async actions
export const generateMeeting = createAsyncThunk(
    'google/create-meeting',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/goole-meet/create-meeting`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("token")}`,
                },
            });
            console.log(response.data)
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const meetDisconnect = createAsyncThunk(
    "meet/disconnect",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/user/meet/disconnect`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("token")}`,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);